module.exports = __webpack_public_path__ + "static/media/31JFA12.d1f91283.jpg";